<template>
    <DemoBoard :isPublic="true"></DemoBoard>
</template>

<script>
    import DemoBoard from "../../components/parametric-search/DemoBoard";

    export default {
        name: "demo-board-view-page",
        components: {
            DemoBoard,
        }
    };
</script>